export default function ConnectWallet({ paired, hashconnect }) {
    // const connectWallet = () => {
    //     hashconnect.openPairingModal();
    // };
    // const disconnectWallet = () => {
    //     hashconnect.disconnect();
    // };
    return (
        <div>
            <button
                // onClick={paired ? disconnectWallet : connectWallet}
                // hover:bg-purple-800 
                className="hidden lg:block cursor-not-allowed bg-[#43385E] w-[130px] h-[45px] rounded-[15px] text-purple-light text-24"> 
                {paired ? "Disconnect" : "Connect"}
            </button>
            <button
                // onClick={paired ? disconnectWallet : connectWallet}
                // hover:bg-purple-800 
                className="block lg:hidden cursor-not-allowed flex justify-center  items-center bg-[#43385E] w-[26px] h-[24px] rounded-[3px]">
                {paired ? 
                <span className="text-purple-light text-sm">0.000</span> : 
                <img
                    src="./assets/icons/mdi_wallet.svg"
                    alt="Wallet Icon"
                    width={22}
                    height={22}
                />}
            </button>
        </div>
    );
}